import React from 'react';
import { FormattedMessage } from 'react-intl';
import MonitorIcon from 'resources/svg/monitor-icon.svg';
import PhoneIcon from 'resources/svg/mobile-phone-icon.svg';
import styles from './CompatibilityWarning.module.scss';

export default function CompatibilityWarning() {
  return (
    <div
      className={styles.container}
      data-testid="login-form-compatibility-warning"
    >
      <div className={styles.title}>
        <FormattedMessage id="LOG_IN_BROWSER_COMPATIBILITY_WARNING" />
      </div>
      <div className={styles.row}>
        <div className={styles.icon}>
          <MonitorIcon />
        </div>
        <div>
          <FormattedMessage
            id="LOG_IN_BROWSER_COMPATIBILITY_DESKTOP"
            values={{
              // eslint-disable-next-line react/display-name
              chrome: chunks => <em>{chunks}</em>,
              // eslint-disable-next-line react/display-name
              firefox: chunks => <em>{chunks}</em>,
            }}
          />
        </div>
      </div>
      <div className={styles.row}>
        <div className={styles.icon}>
          <PhoneIcon />
        </div>
        <div>
          <FormattedMessage
            id="LOG_IN_BROWSER_COMPATIBILITY_MOBILE"
            values={{
              // eslint-disable-next-line react/display-name
              android: chunks => (
                <a
                  href="https://play.google.com/store/apps/details?id=com.xmatters.xmobile"
                  target="_blank"
                  rel="noreferrer"
                >
                  {chunks}
                </a>
              ),
              // eslint-disable-next-line react/display-name
              iOS: chunks => (
                <a
                  href="https://itunes.apple.com/app/xmatters/id409162401?mt=8"
                  target="_blank"
                  rel="noreferrer"
                >
                  {chunks}
                </a>
              ),
            }}
          />
        </div>
      </div>
    </div>
  );
}
